import React from "react";

import { Box, Typography, Container, Grid, Card, Button } from "@mui/material";

import BusinessIcon from "@mui/icons-material/Business";

import HandshakeIcon from "@mui/icons-material/Handshake";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
 
const Acquisitions = () => {

  return (
<Container maxWidth="lg" sx={{ py: 6 }}>
<Typography variant="h3" component="h1" align="center" gutterBottom>

        Acquisitions
</Typography>
<Typography variant="h6" component="h2" align="center" color="textSecondary" paragraph sx={{ mb: 5 }}>

        Growing our business through strategic partnerships
</Typography>
<Box sx={{ my: 4 }}>
<Typography variant="h4" component="h2" gutterBottom>

          Our Acquisition Strategy
</Typography>
<Typography paragraph>

          Del Toro Insurance is actively seeking to acquire established insurance agencies that share our commitment to excellent customer service and community engagement. Our acquisition strategy focuses on creating smooth transitions that benefit clients, staff, and agency owners alike.
</Typography>
<Typography paragraph>

          When you partner with Del Toro Insurance, you gain the resources and support of our established brand while maintaining the local connections you've built over years of service.
</Typography>
</Box>
 
      <Grid container spacing={4} sx={{ my: 4 }}>
<Grid item xs={12} md={4}>
<Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
<BusinessIcon sx={{ fontSize: 60, color: '#ffcc00', mb: 2 }} />
<Typography variant="h5" component="h3" align="center" gutterBottom>

              Agency Acquisitions
</Typography>
<Typography align="center">

              We purchase established insurance agencies from owners looking to retire or pursue new opportunities, ensuring a smooth transition for clients and staff.
</Typography>
</Card>
</Grid>
<Grid item xs={12} md={4}>
<Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
<HandshakeIcon sx={{ fontSize: 60, color: '#ffcc00', mb: 2 }} />
<Typography variant="h5" component="h3" align="center" gutterBottom>

              Book of Business
</Typography>
<Typography align="center">

              We acquire books of business from agents looking to reduce their workload or focus on specific insurance lines while ensuring their clients continue to receive excellent service.
</Typography>
</Card>
</Grid>
<Grid item xs={12} md={4}>
<Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
<TrendingUpIcon sx={{ fontSize: 60, color: '#ffcc00', mb: 2 }} />
<Typography variant="h5" component="h3" align="center" gutterBottom>

              Strategic Partnerships
</Typography>
<Typography align="center">

              We form strategic partnerships with complementary businesses to expand our offerings and reach, creating win-win relationships that benefit all parties.
</Typography>
</Card>
</Grid>
</Grid>
<Box sx={{ my: 6, p: 4, bgcolor: '#f8f8f8', borderRadius: 2 }}>
<Typography variant="h4" component="h2" gutterBottom>

          Interested in discussing an acquisition?
</Typography>
<Typography paragraph>

          If you're considering selling your agency or book of business, we invite you to start a confidential conversation with our acquisitions team. We offer competitive valuations and flexible terms to ensure a beneficial transaction for everyone involved.
</Typography>
<Button variant="contained" sx={{ bgcolor: '#ffcc00', color: 'black', '&:hover': { bgcolor: '#e6b800' } }}>

          Contact Our Acquisitions Team
</Button>
</Box>
</Container>

  );

};
 
export default Acquisitions;
 